import * as Scrivito from 'scrivito';
import { PodcastWidgetAttributes, PodcastWidgetId } from './podcast-widget-definitions';
import { ImageObjectId } from '../../objects';
import { HeadlineWidgetTag } from '../headline-widget';

export const PodcastWidgetClass = Scrivito.provideWidgetClass(PodcastWidgetId, {
  attributes: {
    [PodcastWidgetAttributes.TITLE]: 'string',
    [PodcastWidgetAttributes.TITLE_COMPONENT]: ['enum', { values: Object.values(HeadlineWidgetTag) }],
    [PodcastWidgetAttributes.TEXT]: 'html',
    [PodcastWidgetAttributes.IMAGE]: ['reference', { only: ImageObjectId }],
    [PodcastWidgetAttributes.FILE]: 'binary',
    [PodcastWidgetAttributes.THEME]: [
      'enum',
      {
        values: ['default', 'light', 'gray', 'gray-red', 'red-gray', 'red'],
      },
    ],
  },
});

export type PodcastWidget = InstanceType<typeof PodcastWidgetClass>;
